import { render, staticRenderFns } from "./AkunVerifikasiBiodata.vue?vue&type=template&id=79b617f9&"
import script from "./AkunVerifikasiBiodata.vue?vue&type=script&lang=js&"
export * from "./AkunVerifikasiBiodata.vue?vue&type=script&lang=js&"
import style0 from "./AkunVerifikasiBiodata.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports